import { render, staticRenderFns } from "./DebtorAgingReportView.vue?vue&type=template&id=5837e85c&scoped=true"
import script from "./DebtorAgingReportView.vue?vue&type=script&lang=js"
export * from "./DebtorAgingReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5837e85c",
  null
  
)

export default component.exports